import { useState } from "react";
import { Button } from "newui/components/Button";
import { useMfaStatus } from "newui/features/Settings/hooks/useMfaStatus";
import { TwoFactorAuthModal } from "./TwoFactorAuthModal";

/**
 * PRO-731 — the "Two-Factor Authentication" entry point on My Profile.
 * Label/style flips on `two_factor_enabled`:
 *  - off: solid/primary "Enable Two-Factor Authentication"
 *  - on:  outline/secondary "Manage Two-Factor Authentication"
 * Clicking opens the management view (MfaSettingsSection) inside a modal.
 */
export const TwoFactorAuthTrigger = () => {
	const [isOpen, setIsOpen] = useState(false);
	const { data: status } = useMfaStatus();
	const isEnabled = Boolean(status?.two_factor_enabled);

	return (
		<>
			<Button
				type="button"
				btntype={isEnabled ? "secondary" : "primary"}
				onClick={() => setIsOpen(true)}
				data-testid="two-factor-trigger"
			>
				{isEnabled ? "Manage Two-Factor Authentication" : "Enable Two-Factor Authentication"}
			</Button>
			<TwoFactorAuthModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
		</>
	);
};
